/**
 *
 * The identification number consists of eleven digits. In the first ten digits of the identification number,
 * one digit is exactly twice and another digit is not included (from 2016 a triple digit is also possible,
 * correspondingly then two digits not at all [6] ),
 * the other eight (from 2016: also seven ) Digits exactly simple.
 * The first digit must not be 0 . The eleventh digit, the check digit ,
 * is calculated from the first ten digits of the sequence of digits
 * https://de.wikipedia.org/wiki/Steuerliche_Identifikationsnummer#Aufbau_der_Identifikationsnummer
 *
 * based on logic from
 * https://github.com/LIQIDTechnology/german-tax-id-validator/blob/master/index.js
 * license: MIT (https://github.com/LIQIDTechnology/german-tax-id-validator/blob/master/LICENSE)
 *
 * The MIT License (MIT):
 *
 * Copyright (c) 2016 LIQID
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
let last = function (arr) {
  arr = arr || [];
  let lastIndex = arr.length - 1;
  return lastIndex >= 0 ? arr[lastIndex] : null;
};

let pairs = function (obj) {
  return Object.keys(obj || {}).map(function (key) {
    return [key, obj[key]];
  });
};

let groupBy = function (arr, grouper) {
  var map = {};
  (arr || []).forEach(function (element) {
    var key = grouper(element);
    map[key] = map[key] || [];
    map[key].push(element);
  });
  return map;
};

let identity = function (_) {
  return _;
};

export const validate = (taxId: string) => {
  // make sure the input value is string
  taxId = String(taxId);

  // create array out of string
  let taxIdArray: string[];
  taxIdArray = taxId.split("");

  let taxIdInNumberArray = taxIdArray.map(Number);

  let firstTen = taxIdInNumberArray.slice(0, 10);

  let groupedByIdentiy = pairs(groupBy(firstTen, identity));
  let groupedByNumberOfOccurence = groupBy(groupedByIdentiy, function (pair) {
    return pair[1].length;
  });

  let correct = false;

  if (
    // 1. one digit appears zero times
    groupedByIdentiy.length === 9 &&
    // 2. one digit appears exactly twice
    groupedByNumberOfOccurence[2] &&
    groupedByNumberOfOccurence[2].length === 1 &&
    // 3. and all other digits appear exactly once
    groupedByNumberOfOccurence[1] &&
    groupedByNumberOfOccurence[1].length === 8
  ) {
    correct = true;
    // since 2016 the following is also valid
  } else if (
    // 1. two digits appear zero times
    groupedByIdentiy.length === 8 &&
    // 2. one digit appears exactly three times
    groupedByNumberOfOccurence[3] &&
    groupedByNumberOfOccurence[3].length === 1 &&
    // 3. and all other digits appear exactly once
    groupedByNumberOfOccurence[1] &&
    groupedByNumberOfOccurence[1].length === 7
  ) {
    correct = true;
  }

  // The eleventh digit check
  if (correct) {
    let sum = 0;
    var product = 10;
    for (let i = 0; i <= 9; i++) {
      sum = (firstTen[i] + product) % 10;
      if (sum === 0) {
        sum = 10;
      }
      product = (sum * 2) % 11;
    }

    var checksum = 11 - product;
    if (checksum === 10) {
      checksum = 0;
    }
    if (checksum === last(taxIdInNumberArray)) {
      return true;
    }
  }
  return false;
};
